function getRange (min, max) {
  return min === max ? '' : `${min} - ${max}`;
}

export default class BookingRule {
  data = null;

  constructor (data) {
    this.data = data;
  }

  get id () {
    return this.data.id;
  }

  get iata () {
    return this.data.iataCode;
  }

  get departure () {
    return this.data.departure;
  }

  get arrival () {
    return this.data.arrival;
  }

  get direction () {
    return `${this.departure} - ${this.arrival}`;
  }

  get shc () {
    return this.data.bookingUsingSHC;
  }

  get airplane () {
    return this.data.airplaneCode;
  }

  get flight () {
    return this.data.flightNumber;
  }

  get minWeightPercent () {
    return this.data.minWeightPercent;
  }

  get minVolumePercent () {
    return this.data.minVolumePercent;
  }

  get maxWeightPercent () {
    return this.data.maxWeightPercent;
  }

  get maxVolumePercent () {
    return this.data.maxVolumePercent;
  }

  get minWeight () {
    return this.data.minWeight;
  }

  get minVolume () {
    return this.data.minVolume;
  }

  get maxWeight () {
    return this.data.maxWeight;
  }

  get maxVolume () {
    return this.data.maxVolume;
  }

  get volumeRangePercent () {
    return getRange(this.minVolumePercent, this.maxVolumePercent);
  }

  get weightRangePercent () {
    return getRange(this.minWeightPercent, this.maxWeightPercent);
  }

  get volumeRange () {
    return getRange(this.minVolume, this.maxVolume);
  }

  get weightRange () {
    return getRange(this.minWeight, this.maxWeight);
  }

  get result () {
    return this.data.result;
  }

  get priority () {
    return this.data.priority;
  }

  get notApplicable () {
    return !this.data.applicable;
  }

  get fullName () {
    return `${this.direction} | ${this.result}`;
  }

  get abilityProps () {
    return {
      company: this.iata,
      departure: this.departure,
      arrival: this.arrival,
    };
  }
};
